const ALLOWED_EXACT = new Set(["/", "/manage-model", "/manage-template", "/config", "/config/new"]);

export function normalizePvtIframePath(raw) {
  const path = String(raw || "/")
    .trim()
    .replace(/\/+$/, "") || "/";
  if (ALLOWED_EXACT.has(path)) {
    return path;
  }
  if (path.startsWith("/config/edit/")) {
    return path;
  }
  return "/";
}

export function pvtPathFromFluidsRoute(route) {
  const raw = route?.params?.pvtPage;
  if (!raw || (Array.isArray(raw) && raw.length === 0)) {
    return "/";
  }
  const parts = (Array.isArray(raw) ? raw : [raw]).filter(Boolean);
  return normalizePvtIframePath(`/${parts.join("/")}`);
}

export function fluidsPvtPath(tenantId, pvtPath) {
  const tenant = String(tenantId || "").trim();
  const path = normalizePvtIframePath(pvtPath);
  const suffix = path === "/" ? "" : path;
  return `/${tenant}/pvt-prediction${suffix}`;
}
const PVT_PAGE_TITLES = {
  "/manage-model": "AI Model Parameters",
  "/manage-template": "AI Predicted Tests",
  "/config": "AI Model Parameters",
  "/config/new": "AI Model Parameters",
};

function pvtPageTitle(path) {
  if (PVT_PAGE_TITLES[path]) {
    return PVT_PAGE_TITLES[path];
  }
  if (path.startsWith("/config/edit/")) {
    return "AI Model Parameters";
  }
  return null;
}

export function buildPvtBreadcrumbItems(pvtPath) {
  const path = normalizePvtIframePath(pvtPath);
  const root = { title: "PVT Prediction", pvtPath: "/" };

  if (path === "/") {
    return [{ ...root, nonNav: true }];
  }

  const pageTitle = pvtPageTitle(path);
  if (!pageTitle) {
    return [{ ...root, nonNav: true }];
  }

  return [
    { ...root, nonNav: false },
    { title: pageTitle, nonNav: true },
  ];
}

